import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { rateWatch, rateUpdatedAt } from './data';
export function RateWatch() {
  return <section className="bg-navy-600 rounded-xl p-5 text-white" aria-label="Rate watch" data-id="element-890" data-mp="2086gsu5hiz5f">
      <div className="flex items-center justify-between mb-4" data-id="element-891" data-mp="257j3newcw680">
        <h3 className="text-base font-serif font-bold" data-id="element-892" data-mp="2a1ndq70x4udb">Rate Watch</h3>
        <span className="text-[0.65rem] text-navy-200 uppercase tracking-wide" data-id="element-893" data-mp="2e2h18zag875o">
          {rateUpdatedAt}
        </span>
      </div>

      <ul className="divide-y divide-white/10" data-id="element-894" data-mp="2iz7hpnq614rm">
        {rateWatch.map(r => {
        const up = r.change > 0;
        const down = r.change < 0;
        return <li key={r.product} className="flex items-center justify-between py-2.5" data-id="element-895" data-mp="2sxx0dipvyt8x">
              <div data-id="element-896" data-mp="tnf6djopyrm9">
                <p className="text-sm font-semibold" data-id="element-897" data-mp="to6z8mqxmb8u">{r.product}</p>
                <p className="text-[0.7rem] text-navy-200" data-id="element-898" data-mp="ylgxmrwatx8t">APR {r.apr}</p>
              </div>
              <div className="text-right" data-id="element-899" data-mp="1ayqbt6imw0js">
                <p className="text-base font-bold text-gold-400 leading-none" data-id="element-900" data-mp="1azrmh9vqml0z">
                  {r.rate}
                </p>
                <span className={`inline-flex items-center gap-0.5 text-[0.7rem] font-semibold mt-0.5 ${down ? 'text-sage' : up ? 'text-blush' : 'text-navy-200'}`} data-id="element-901" data-mp="117lzkekcetsn">
                  {down ? <ArrowDownRight className="w-3 h-3" data-id="element-902" data-mp="1tvhpn0fepngg" /> : up ? <ArrowUpRight className="w-3 h-3" data-id="element-903" data-mp="1oyremrigli1w" /> : <Minus className="w-3 h-3" data-id="element-904" data-mp="1jy3m21el0t5k" />}
                  {r.change === 0 ? 'flat' : `${Math.abs(r.change)} bps`}
                </span>
              </div>
            </li>;
      })}
      </ul>

      <p className="text-[0.65rem] text-navy-300 mt-3 leading-snug" data-id="element-905" data-mp="8k9ek8ttyu1g">
        Internal pricing reference only — not a consumer rate quote.
      </p>
    </section>;
}